import React from 'react';
import { BarProps } from 'recharts';

const RADIUS = 10;
const GAP = 3;
const BASELINE_GAP = 4;
const PADDING = 4;

type BarShapeProps = Omit<BarProps, 'dataKey'> & {
  color?: string;
  value?: [number, number];
};

export default function BarShape(props: BarShapeProps) {
  const { color, fill, x, y, width, height, value } = props;

  if (!height || height <= 0) return null;

  const isAtBaseline = Array.isArray(value) && value[0] === 0;
  const bottomGap = isAtBaseline ? BASELINE_GAP : GAP / 2;
  const adjustedX = Number(x) + PADDING;
  const adjustedY = Number(y) + GAP / 2;
  const adjustedWidth = Math.max(Number(width) - PADDING * 2, 0);
  const adjustedHeight = Math.max(height - GAP / 2 - bottomGap, 0);

  const r = Math.min(RADIUS, adjustedWidth / 2, adjustedHeight / 2);

  return (
    <rect
      x={adjustedX}
      y={adjustedY}
      width={adjustedWidth}
      height={adjustedHeight}
      fill={color || fill}
      rx={r}
      ry={r}
    />
  );
}
